import { render, staticRenderFns } from "./SettledTable.vue?vue&type=template&id=6a36840d&"
import script from "./SettledTable.vue?vue&type=script&lang=js&"
export * from "./SettledTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports